import { createContextStore } from "@faire/web/ui/hooks/ContextStore";

import { Category } from "@faire/retailer/models/Category/Category";

const initialStore = {
  category: null as Category | null,
  navigationPath: null as string | null,
};

export const {
  Provider: CurrentCategoryPageContextProvider,
  useStore: useCurrentCategoryPage,
} = createContextStore(initialStore, { name: "CurrentCategoryPageContext" });
